import React from "react";

import {
    Alignment,
    FlexBehaviour,
    FlexDirection,
    Position,
    Side,
    Size,
} from "../../types/system/Layout";
import Utilities from "../../foundation/Utility";

interface GeneralContainerProps {
    className?: string;
    style?: React.CSSProperties;

    scaling?: boolean;
    mid?: boolean;
    max?: boolean;
    fitContent?: boolean;

    position?: Position;

    fullWidth?: boolean;
    fullHeight?: boolean;

    alignment?: Alignment;
    overflow?: Side;

    flex?: FlexDirection;
    flexSpaced?: boolean;
    flexBehaviour?: FlexBehaviour;
    flexWrapped?: boolean;

    clearanceSide?: Side;
    clearanceSize?: Size;

    bufferSide?: Side;
    bufferSize?: Size;

    ruleSide?: Side;
    ruleDark?: boolean;

    children?: any;
}

class GeneralContainer extends React.Component<GeneralContainerProps> {
    render(): React.ReactNode {
        let classes = this.props.className ?? "";

        switch (this.props.position) {
            case "relative":
                classes += " relative";
                break;
            case "absolute":
                classes += " absolute";
                break;
            case "fixed":
                classes += " fixed";
                break;
            case "sticky":
                classes += " sticky";
                break;
        }

        // Scaling classes
        if (this.props.scaling) {
            classes += " scaling-pane";
            if (this.props.mid)
                if (this.props.max) classes += "-midmax";
                else classes += "-mid";
            else if (this.props.max) classes += "-max";
        }

        // Clearance classes
        if (!!this.props.clearanceSide) {
            classes += ` ${Utilities.getSideClass(
                this.props.clearanceSide,
            )}clearance${Utilities.getSizeClass(this.props.clearanceSize)}`;
        }

        // Buffer classes
        if (!!this.props.bufferSide) {
            classes += ` ${Utilities.getSideClass(
                this.props.bufferSide,
            )}buffer${Utilities.getSizeClass(this.props.bufferSize)}`;
        }

        // Rule classes
        if (!!this.props.ruleSide) {
            classes += ` ${Utilities.getSideClass(this.props.ruleSide)}rule${
                this.props.ruleDark ? "-dark" : ""
            }`;
        }

        // Size classes
        if (this.props.fullWidth) classes += " full";
        if (this.props.fullHeight) classes += " full-height";

        // Contain classes
        if (this.props.fitContent) classes += " fit-content";

        // Alignment classes
        if (this.props.alignment) {
            switch (this.props.alignment) {
                case "left":
                    classes += " left";
                    break;
                case "center":
                    classes += " center";
                    break;
                case "right":
                    classes += " right";
                    break;
            }
        }

        // Overflow classes
        if (this.props.overflow) {
            switch (this.props.overflow) {
                case "vertical":
                    classes += " overflow-vertical";
                    break;
                case "horizontal":
                    classes += " overflow-horizontal";
                    break;
                case "all":
                    classes += " overflow-all";
                    break;
            }
        }

        switch (this.props.flex) {
            case "row":
                classes += " flex-row";
                break;
            case "column":
                classes += " flex-column";
                break;
            case "reverse-row":
                classes += " flex-row-reverse";
                break;
            case "reverse-column":
                classes += " flex-column-reverse";
                break;
        }

        switch (this.props.flexBehaviour) {
            case "min":
                classes += " col-pane";
                break;
            case "max":
                classes += " col";
                break;
        }

        if (this.props.flexSpaced) classes += " spaced";

        if (this.props.flexWrapped) classes += " flex-wrapped";

        return (
            <div
                className={`general-container ${classes}`}
                style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}

export default GeneralContainer;
